import * as React from 'react';

export function WhyImpact() {
  return (
    <section className="ong-impact">
      <style>{`
        .ong-impact {
          padding: 72px 24px;
          background: #fff;
        }
        .ong-impact-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .ong-impact h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .ong-impact .accent {
          font-size: 22px;
          font-weight: 600;
          color: #1EAA25;
          margin: 0 0 28px;
        }
        .ong-impact p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .ong-impact .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .ong-impact-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .ong-impact-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #333;
          padding: 10px 14px;
          background: #f0fdf0;
          border-radius: 8px;
        }
        .ong-impact-list li i {
          color: #1EAA25;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .ong-impact h2 {
            font-size: 24px;
          }
          .ong-impact-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="ong-impact-inner">
        <h2>Cada plato que servís es una oportunidad.</h2>
        <p className="accent">De nutrir, de cuidar, de transformar.</p>
        <p>
          Las personas que llegan a tu comedor <span className="highlight">confían en que van a recibir un plato digno</span>.
          Frutas y verduras frescas no son un lujo: son lo mínimo que merecen.
        </p>
        <p>
          Una organización que alimenta bien <span className="highlight">multiplica su impacto</span>.
          Y las comunidades, los donantes y los organismos lo valoran.
        </p>
        <ul className="ong-impact-list">
          <li><i className="fa fa-check-circle" /> Mejor nutrición para los beneficiarios</li>
          <li><i className="fa fa-check-circle" /> Compromiso visible con el bienestar</li>
          <li><i className="fa fa-check-circle" /> Familias y comunidades más conformes</li>
          <li><i className="fa fa-check-circle" /> Impacto real con cada entrega</li>
        </ul>
      </div>
    </section>
  );
}
